<div class="toggle-current-selections-container">
  <app-filter-drawer-toggle></app-filter-drawer-toggle>
  <app-filter-current-selections-display (overflowingChips)="overflowingCurrentSelections = $event"></app-filter-current-selections-display>
  <app-filter-chip-overflow [overflowingCurrentSelections]="overflowingCurrentSelections"></app-filter-chip-overflow>
</div>
